import { render, staticRenderFns } from "./childreport.vue?vue&type=template&id=150ef4bb&"
import script from "./childreport.vue?vue&type=script&lang=js&"
export * from "./childreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports